// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2b6bdc68] tbody tr.v-data-table__expanded__content {\n  background: #efefef;\n  box-shadow: none !important;\n}", ""]);
// Exports
module.exports = exports;
